// import helpers from "../helpers/helpers";
export default {
  modelName: 'act_cnt_update',
  versionModelName: 'act_version',
  label: '我的法規內容格式更新作業',
};
